import React from 'react';
import uploadedLogo from '../../../../../assets/images/uploaded-logo.png'

export default function TopHeading() {
    return (
        <div className="question-wrapper-Heading">
            <div className="heading">
                <div className="logo-wrapper">
                    <img src={uploadedLogo} alt="" width={60} />
                </div>
                <h1>Threat management</h1>
                <p>Unified threat management is an approach to information security where a single hardware or software installation provides multiple security functions</p>
            </div>
        </div>

    )
}


